import { object, string, ref } from "yup";

export interface SetCustomerCredentials {
  dmsDealerId: string;
  customerId: number;
  password: string;
  confirmPassword: string;
}
export const CustomerCredentialsInitialValues: SetCustomerCredentials = {
  dmsDealerId: "",
  customerId: 0,
  password: "",
  confirmPassword: "",
};

export const CustomerCredentialsValidationSchema = object().shape({
  password: string()
    .required("Please enter a password")
    .min(8, "Password must have at least 8 characters"),
  confirmPassword: string()
    .required("Please re-type your password")
    .oneOf([ref("password")], "Passwords does not match"),
});
